import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/constants.css';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { FriendsProvider } from './contexts/FriendsContext';
import { ResultsProvider } from './contexts/ResultsContext';
import { ToastProvider } from './contexts/ToastContext';
import reportWebVitals from './reportWebVitals';
import {
  TournamentAppConfigurationProvider,
} from "./utils/tournamentconfig/TournamentConfiguration"

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <TournamentAppConfigurationProvider>
          <AuthProvider>
            <FriendsProvider>
              <ResultsProvider>
                <App />
              </ResultsProvider>
            </FriendsProvider>
          </AuthProvider>
        </TournamentAppConfigurationProvider>
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();